export const HELPLINES = [
  {
    id: 'rpf-security',
    title: 'RPF Security & Threat Response',
    number: '182',
    category: 'Railway Police & Crime',
    description: 'Direct railway police control room for harassment, theft, unauthorized intrusion, or safety threats.',
    color: '#DC2626',
    badge: 'Security 24x7',
    primary: true,
  },
  {
    id: 'rpf-security',
    title: 'RPF Security & Threat Response',
    number: '182',
    category: 'Railway Police & Crime',
    description: 'Direct railway police control room for harassment, theft, unauthorized intrusion, or safety threats.',
    color: '#EA580C',
    badge: 'Security',
    primary: true,
  },
  {
    id: 'national-emergency',
    title: 'National Emergency Response (ERSS)',
    number: '112',
    category: 'Police / Fire / Disaster',
    description: 'Single national emergency number across India that coordinates with state police & emergency services.',
    color: '#2563EB',
    badge: 'Police / Fire',
    primary: false,
  },
  {
    id: 'ambulance',
    title: 'Medical Ambulance Coordination',
    number: '108',
    category: 'Medical Critical',
    description: 'Emergency ambulance dispatch at upcoming stations for critical patient emergencies.',
    color: '#16A34A',
    badge: 'Ambulance',
    primary: false,
  },
  {
    id: 'women-safety',
    title: 'Women in Distress Helpline',
    number: '1091',
    category: 'Women Passenger Safety',
    description: '24x7 female emergency desk for safety, stalking, harassment, or solo traveler assistance.',
    color: '#DB2777',
    badge: 'Women Safety',
    primary: false,
  },
];

export const EMERGENCY_TYPES = [
  { id: 'Medical Emergency', label: '🚑 Medical Emergency', desc: 'Sudden illness, heart attack, injury' },
  { id: 'RPF / Security Threat', label: '👮 Security / Threat', desc: 'Harassment, fight, unauthorized passenger' },
  { id: 'Women Safety', label: '👩 Women Safety', desc: 'Threat or unsafe situation for female traveler' },
  { id: 'Theft / Lost Property', label: '🎒 Theft / Lost Child', desc: 'Luggage stolen, missing child/relative' },
  { id: 'Coach Hazard / Fire', label: '🔥 Fire / Coach Hazard', desc: 'Smoke, short circuit, water/light failure' },
  { id: 'Other Emergency', label: '⚠️ Other Urgent Issue', desc: 'General critical problem' },
];
